import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FilesService } from './../../../services';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-new-image',
  templateUrl: './dialog-new-image.component.html',
  styleUrls: ['./dialog-new-image.component.scss']
})
export class DialogNewImageComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<DialogNewImageComponent>,
    private _files: FilesService,
    private formBuilder: FormBuilder
  ) {
    this.form = this.formBuilder.group({
      image: [null, Validators.required],
      alt: [null, Validators.required]
    });
  }

  waiting = false;
  public form: FormGroup;
  h2 = 'Фотохранилище | Создание';
  url1: string;
  picture: any;

  public onSubmit() {
    // console.log("onSubmit");
    const controls = this.form.controls;
    if (this.form.invalid) {
      Object.keys(controls)
      .forEach(controlName => controls[controlName].markAsTouched());
      // Breake run method 
      return;
    }
    let data = this.form.value;
    this.create(data);
  }

  create(data):void {
    this.waiting = true;
    this._files.create(data).subscribe(
      res => {
        this.waiting = false;
        // console.log("CREATED",  res);
        this.dialogRef.close({});
      },
      err => {
        this.waiting = false;
        console.warn('New photo');
      }
    );
  }

  onSelectFile(event) { // called each time file input changes
    if (event && event[0] && 
      (event[0].type === 'image/jpeg' || event[0].type === 'image/jpg' || 
      event[0].type === 'image/png' || event[0].type === 'image/gif' || 
      event[0].type === 'image/bmp')
    ) {
      this.picture = event[0];
      var reader = new FileReader();

      reader.readAsDataURL(event[0]); // read file as data url

      reader.onload = (event: any) => { // called once readAsDataURL is completed
        let url = event.target.result;
          this.url1 = url;
          this.form.controls["image"].setValue(this.picture);
          this.form.controls["alt"].markAsTouched();
      }
    }
  }

  clearFile() {
    this.url1 = '';
    this.picture = undefined;
    this.form.controls["image"].setValue(null);
  }

  ngOnInit() {
  }

}
